import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export type Fact = [label: string, value: ReactNode];

/**
 * A table row's cells as label/value pairs, two to a line — what a phone shows instead of a
 * dozen-column table. Each value is its own element, so it reads (and is found) the same way a
 * cell would.
 */
export const Facts = ({ items, columns = 2 }: { items: Fact[]; columns?: 1 | 2 }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: columns === 2 ? 'auto minmax(0, 1fr) auto minmax(0, 1fr)' : 'auto minmax(0, 1fr)',
      columnGap: 1.5,
      rowGap: 0.25,
      alignItems: 'baseline'
    }}
  >
    {items.map(([label, value]) => (
      // A fragment per pair: label and value are siblings in the grid, so the columns line up.
      <Box key={label} sx={{ display: 'contents' }}>
        <Typography variant="caption" color="text.secondary" noWrap>
          {label}
        </Typography>
        <Typography variant="body2" component="div" sx={{ overflowWrap: 'anywhere' }}>
          {value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default Facts;
